import React, { useState, useCallback } from 'react';
import Modal from 'react-modal';
import { IntlProvider, FormattedMessage } from 'react-intl';

const ModalDetail = (props) => {
  const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)'
  }
};

const {detail, modalIsOpen, closeModal} = props;
  return (
    <>
    <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Example Modal"
        >

          <div className="itemDetail">

            <div className="itemDetail__imageWrapper">
              <img className="itemDetail__img" src={detail.img}></img>
            </div>

            <div className="itemDetail__detailPanel">
              <h2 className="itemDetail__title">{detail.name}</h2>
              <p className="itemDetail__description">{detail.description}</p>

              <h3 className="itemDetail__titleSection"><FormattedMessage id={"label.composizione"}/></h3>
              <p className="itemDetail__contentSection">{detail.composition}</p>

              <h3 className="itemDetail__titleSection"><FormattedMessage id={"label.manutenzione"}/></h3>
              <p className="itemDetail__contentSection">{detail.maintenance}</p>

              <div className="itemDetail__variantsWrapper">
                {detail && detail.variants.map( (item) => (
                  <div className="itemVariant">
                    <div className="itemVariant__imgWrapper" >
                      <img src={item.img}></img>
                    </div> 
                    <div className="itemVariant__title" >{item.name}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
      </Modal>
    </>
    )
}

export default ModalDetail;